import { CardContent, CardHeader, Stack, Paper, styled } from "@mui/material";
import { useTranslation } from "react-i18next";
import React, { useMemo, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import PDFButton from "./PDFButton";
import { getNumericDate } from "../../../_utils/getNumericDate";
import DownloadPDFMercure from "../../common/buttons/DownloadPDFMercure";

const FilePaper = styled(Paper)(({ theme }: any) => ({
  mt: 2,
  borderRadius: "23px",
  boxShadow: theme.customShadows.z8,
}));

const ProfileFileList: React.FC<{ person?: any; testData?: any[] }> = ({
  person,
  testData,
}) => {
  const home = useSelector((state: any) => state.home);
  const { isCollab } = useSelector((state: any) => state.auth);
  const canDownload = (home?.paramjson?.candidatePdf && isCollab) || !isCollab;

  const { t } = useTranslation("common");

  console.log("testData", testData);
  console.log("person", person);

  const [allowedTests] = useState([
    {
      code: "b5",
      label: t("tests.title.b5"),
      typeName: t("tests.b5"),
      type: "b5",
    },
    {
      code: "inc",
      label: t("tests.title.inc"),
      typeName: t("tests.dynamics"),
      type: "inc",
    },
  ]);

  const hasCustomTest = Boolean(
    testData?.find?.((el) => el.code === "ac-mt-diag" && el.isPassed)
  );

  const filteredTestData = useMemo(
    () => [
      {
        type: "profile",
        label: t(`pdf.${"selection_not_collab"}`),
        typeName: t("profile"),
      },
      ...(testData
        ?.filter((el) => el.isPassed)
        ?.filter((test) => {
          const testCode = test.code;
          const isAllowed = allowedTests.some(
            (allowedTest) => allowedTest.code === testCode
          );
          return isAllowed;
        })
        .map((test) => {
          const allowedTest = allowedTests.find(
            (allowedTest) => allowedTest.code === test.code
          );
          return {
            ...test,
            label: allowedTest?.label || test.label,
            typeName: allowedTest?.typeName || test.typeName,
            type: allowedTest?.type || test.type,
            datePassed: getNumericDate(test.datePassed),
          };
        }) ?? []),
    ],
    [t, testData, allowedTests]
  );

  const tokenData = useSelector((state: any) => state.user, shallowEqual);

  const buttonsProps = {
    token: tokenData.token_pdf,
    fullName: person
      ? `${person.firstName}_${person.lastName}`
      : `${tokenData.firstName}_${tokenData.lastName}`,
    personId: person?.id || tokenData.person_id,
  };

  if (!canDownload) return null;

  return (
    <FilePaper elevation={3}>
      <CardHeader
        title={t(`downloads`)}
        titleTypographyProps={{ variant: "subtitle2" }}
      />
      <CardContent>
        <Stack spacing={2}>
          {filteredTestData?.map((test) => (
            <>
              <PDFButton key={test.code} {...test} {...buttonsProps} />
              {test.code === "inc" && (
                <PDFButton
                  type="synthesis"
                  label={t(`pdf.${"synthesis"}`)}
                  typeName={t(`tests.${"synthesis"}`)}
                  {...buttonsProps}
                />
              )}
            </>
          ))}

          {hasCustomTest && <DownloadPDFMercure type="diag" />}
        </Stack>
      </CardContent>
    </FilePaper>
  );
};

export default ProfileFileList;
